import styled from 'styled-components';

export const AudioRecorderStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
